import { useApi } from '@/components/Functional/hooks-core/useApi'
import { useRaundStore } from '@/store/useRaundStore'

export const usePresentCount = () => {
  const { setNewRewardsCount } = useRaundStore()
  const api = useApi()

  const setPresentCount = async () => {
    try {
      const result = await api.auth.fetchPresentCount()
      if (result) {
        setNewRewardsCount(result.count)
      }
    } catch (error) {}
  }
  return { setPresentCount }
}
